import { useMutation, useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { toast } from "sonner";
import { AxiosError } from "axios";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/dialog";

import { useTakeActionModal } from "./use-action-modal";
import { Button } from "@/components/ui/button/button";
import { disableLeadTriggerAction } from "@/config/mutation/employee/lead";

export const DisableLeadReminderModal = () => {
  const queryClient = useQueryClient();
  const key = Cookies.get("key") as string;
  const { open, onOpenChange, lead, setLead } = useTakeActionModal();

  const { mutate, isPending } = useMutation({
    mutationFn: disableLeadTriggerAction(key),
  });

  const submitAction = async () => {
    mutate(lead?.id as string, {
      onSuccess: async () => {
        // console.log("New Employee", data);
        await queryClient.invalidateQueries({
          queryKey: ["lead-reminders"],
        });

        toast.success("Action Taken.");
        onOpenChange(false);
      },

      onError: (error) => {
        console.log("ERROR WHILE DISABLING REMINDER OF LEAD", error);
        const isAxiosError = error instanceof AxiosError;
        if (isAxiosError) {
          const errorReason = error?.response?.data?.error as string;
          toast.error(errorReason);
        } else {
          toast.error(error?.message);
        }
      },
    });
  };

  return (
    <>
      <Dialog
        open={open}
        onOpenChange={(open) => {
          onOpenChange(open);
          setLead(null);
        }}
      >
        <DialogContent className="max-w-xl">
          <DialogHeader>
            <DialogTitle>Do you want to disable this reminder?</DialogTitle>
            <DialogDescription>
              If you have worked on corresponding lead just before reminder, you
              can disable its reminder.
            </DialogDescription>
          </DialogHeader>

          <div className="flex items-center justify-end">
            <Button onClick={submitAction} disabled={isPending}>
              Submit
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
